<script lang="ts">
export default {
  name: "OrderBuyProStatusO",
  functional: true,
  props: {
    row: Object,
    column: String
  },
  render: function (createElement, context) {
    const col = context.props.column;
    const val = context.props.row[col];

    if (val == 0) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--info el-tag--light ",
          style: "color:black;"
        },
        "Sin Estado Orden"
      );
    }
    if (val == 1) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--info el-tag--dark",
          style: "color:white;"
        },
        "En Fabrica"
      );
    }
    if (val == 2) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--primary el-tag--light ",
          style: "color:black;"
        },
        "En Tránsito"
      );
    }
    if (val == 3) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--primary el-tag--dark",
          style: "color:white;"
        },
        "En Aduana"
      );
    }
    if (val == 4) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--info el-tag--dark",
          style: "color:white;"
        },
        "Magycorp"
      );
    }
    if (val == 5) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--success el-tag--light ",
          style: "color:black;"
        },
        "Despachado Cliente"
      );
    }
    if (val === 6) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--success el-tag--dark",
          style: "color:white;"
        },
        "Entregado"
      );
    }
    if (val == 7) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--danger el-tag--dark",
          style: "color:white;"
        },
        "Pendiente de Pago"
      );
    }

    return createElement("");
  }
};
</script>
